import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { useNewPhotoLifeCycleStep } from 'hooks/useNewPhotoLifeCycleStep';
import { useOptions } from 'hooks/useOptions';
import { useTranslation } from 'hooks/useTranslation';
import React, { HtmlHTMLAttributes, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { setSelfeAppStateAction } from 'store/features/app/selfeAppSlice';
import { useAppDispatch } from 'store/store-hooks';

export type UserExperienceProps = HtmlHTMLAttributes<HTMLDivElement> & {};

const UserExperience = ({ ...props }: UserExperienceProps) => {
  const { T } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { getNextPath } = useNewPhotoLifeCycleStep();
  const { emotionList } = useOptions();

  const handleUserExperience = (emotionId: number) => {
    dispatch(setSelfeAppStateAction({ satisfactionLevel: emotionId }));
    navigate(getNextPath());
  };

  return (
    <>
      <div className="user-exp-container">
        <Typography className="user-exp-title" variant={TYPOGRAPHY_VARIANTS.H1}>
          {T('giveFeedback')}
        </Typography>
        <div className="user-exp-emotions">
          {emotionList.map((emotion) => (
            <div
              key={emotion.id}
              className="user-exp-emotion"
              onClick={() => handleUserExperience(emotion.id)}
              aria-hidden="true"
              {...props}
            >
              <div className="user-exp-icon">{emotion.icon}</div>
              <Typography
                className="exp-icon-title"
                variant={TYPOGRAPHY_VARIANTS.H2}
              >
                {emotion.label}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default memo(UserExperience);
